<ion-spinner *ngIf="!assessment" class="assessment" name="dots" color="secondary"></ion-spinner>
<app-warning *ngIf="assessment && !enableNext && type == sleepEfficiencyType"
             text="assessment.error.errorSleepEfficiency"
             headerLeft="assessment.error.totalSleepTime"
             [headerRight]="timeError"
             color="tertiary"
             [horizontalMargin]="false"
             [icon]="null"
></app-warning>
<app-warning *ngIf="assessment && !enableNext && type == timeInBedType"
             text="assessment.error.errorTimeInBed"
             headerLeft="assessment.error.totalInBed"
             [headerRight]="timeError"
             color="light-warning"
             [horizontalMargin]="false"
             [icon]="null"
></app-warning>
<ion-list lines="none" *ngIf="assessment">
    <ion-item class="paragraph-15 ion-no-padding">
        <ion-label>{{'assessment.error.inBedAt' |translate}}</ion-label>
        <input type="time" [(ngModel)]="inBedAt"
               [readonly]="app === 'self-guided'"
               [disabled]="loading"
               (ngModelChange)="answerInBedAt()"/>
    </ion-item>
    <ion-item class="paragraph-15 ion-no-padding" *ngIf="type == sleepEfficiencyType">
        <div class="inside-button">
            <ion-label class="paragraph-15">{{'assessment.error.timeToSleepPart1' |translate}}</ion-label>
            <ion-button class="picker" mode="ios" expand="block"
                        [disabled]="loading"
                        (click)="openNumberPickerTimeToSleep()">{{timeToSleep}}</ion-button>
            <ion-label>{{'assessment.error.timeToSleepPart2' |translate}}</ion-label>
        </div>
    </ion-item>
    <ion-item class="paragraph-15 ion-no-padding" *ngIf="type == sleepEfficiencyType && timeAwake != null">
        <div class="inside-button">
            <ion-label class="paragraph-15">{{'assessment.error.timeAwakePart1' |translate}}</ion-label>
            <ion-button class="picker" mode="ios" expand="block"
                        [disabled]="loading"
                        (click)="openNumberPickerTimeAwake()">{{timeAwake}}</ion-button>
            <ion-label>{{'assessment.error.timeAwakePart2' |translate}}</ion-label>
        </div>
    </ion-item>
    <ion-item class="paragraph-15 ion-no-padding">
        <ion-label class="paragraph-15">{{'assessment.error.wokeUpAt' |translate}}</ion-label>
        <input type="time" [(ngModel)]="wokeUpAt"
               [readonly]="app === 'self-guided'"
               [disabled]="loading"
               (ngModelChange)="answerWokeUpAt()"/>
    </ion-item>
    <ion-item class="paragraph-15 ion-no-padding" *ngIf="type == timeInBedType">
        <div class="inside-button">
            <ion-label class="paragraph-15">{{'assessment.error.timeToGetOutBedPart1' |translate}}</ion-label>
            <ion-button class="picker" mode="ios" expand="block"
                        [disabled]="loading"
                        (click)="openNumberPickerTimeToGetOutBed()">{{timeToGetOutBed}}</ion-button>
            <ion-label>{{'assessment.error.timeToGetOutBedPart2' |translate}}</ion-label>
        </div>
    </ion-item>
</ion-list>

<haleo-button-next *ngIf="app === 'self-guided'"
                   [label]="'assessment.nextQuestion' | translate"
                   [disabled]="(type == sleepEfficiencyType && !enableNext) || loading"
                   [loading]="loading"
                   [type]="'next'"
                   (next)="next()">
</haleo-button-next>

<ion-button *ngIf="app === 'haleo'"
            class="next" expand="block"
            [disabled]="(type == sleepEfficiencyType && !enableNext) || loading"
            (click)="next()">
    <span *ngIf="!loading">{{'assessment.nextQuestion' | translate}}</span>
    <ion-spinner *ngIf="loading" name="dots" color="secondary"></ion-spinner>
</ion-button>
